export default "__VITE_ASSET__CNY02Pdi__"